<template>
  <v-dialog v-model="dialog" max-width="600">
    <ValidationObserver ref="uploadAttachmentForm" v-slot="{ invalid, passes }">
      <form
        rel="uploadAttachmentForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7"> Nahrát přílohy </v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="name"
                  rules="required|order-attachment-name"
                  mode="lazy"
                  counter="50"
                  outlined
                  dense
                  label="Název"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VFileInputWithValidation
                  v-model="files"
                  :rules="{
                    required: true,
                    ext: ['pdf', 'csv', 'xlsx', 'doc', 'docx', 'png', 'jpg', 'jpeg'],
                    size,
                  }"
                  prepend-icon=""
                  append-icon="$file"
                  :clearable="false"
                  outlined
                  counter
                  multiple
                  :show-size="1000"
                  label="Nahrajte přílohy (.pdf, .csv, .xlsx, .doc, .docx, .png, .jpg, .jpeg)"
                  @change="setFile($event)"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Nahrát
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'OrderUploadAttachmentDialog',
  data() {
    return {
      name: null,
      files: null,
      saving: false,
      dialog: false,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('uploadAttachmentDialog', function (dialog) {
      model.name = null
      model.files = null
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      uploadAttachment: 'order/uploadOrderAttachment',
    }),
    setFile(event) {
      this.files = event
    },
    submit() {
      this.saving = true
      this.uploadAttachment({
        id: this.$route.params.orderId,
        name: this.name,
        files: this.files,
      }).finally(() => {
        this.saving = false
        this.$refs.uploadAttachmentForm.reset()
        this.$emit('attachmentUploaded')
        this.close()
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
